import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import errorResponseInterceptor from './interceptors';

// Create instance
const baseURL = process.env.VUE_APP_API_HOST;

const client = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
});

// Add a response interceptor to handle http error
client.interceptors.response.use((response) => response, errorResponseInterceptor);

export default client;
